import { InjectionToken } from "@angular/core";
import { Routes } from "@angular/router";
import { Language } from "@shared/modules/locale/types/language.type";
import { ProductEnum } from "environments/products/product.enum";

interface Condition {
    stepName?: string;
    param?: string;
    subParam?: string;
    values?: string[];
    negotiate?: boolean;
    dependency?: SkipStep;
    langInstance?: string; 
    or?: SkipStep,
    and?: SkipStep
}

export interface SkipStep {
    skipStepName: string;
    conditions: Array<Condition>;
}

export interface LangInstanceConfig {
    languages: Language[],
    googleMapsOptions: {
        center: {
            lat: number;
            lng: number;
        },
        zoom: number
    },
    phoneValidationHint: string;
    currency: string;
    phonePrefix: string;
    infoline: string;
}

interface ProductsConfig {
    [name: string]: ProductConfig
}

/**
 * @param baseUrl
 */
export interface ProductConfig {
    baseUrl: string;
    productUrl: string;
    schemaEndpoint: string;
    skipSteps?: SkipStep[];
    maxSingleFileSizeUpload: number | null;
    maxBulkFilesSizeUpload: number;
    deployUrl: string;
}

export interface EnvironmentInterface {
    production: boolean;
    productsConfig: ProductsConfig;
    langInstance: string;
    langInstanceConfig: LangInstanceConfig,
    googleMapsAPI?: string; // remove???
}

export const ENV = new InjectionToken<EnvironmentInterface>('Environment');
export const DEPLOY_URL = new InjectionToken<string>('DeployUrl');
export const PRODUCT = new InjectionToken<ProductEnum>('product');
export const PRODUCT_ROUTES = new InjectionToken<Routes>('ProductRoutes');